var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.516,
    height: 27.613,
    viewBox: "0 0 34.516 27.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "robot",
    d: "M0,13.806v6.9a1.724,1.724,0,0,0,1.726,1.726H3.452V12.081H1.726A1.724,1.724,0,0,0,0,13.806ZM25.024,5.177h-6.04V1.726a1.726,1.726,0,0,0-3.452,0V5.177H9.492A4.313,4.313,0,0,0,5.177,9.492V24.161a3.455,3.455,0,0,0,3.452,3.452H25.887a3.455,3.455,0,0,0,3.452-3.452V9.492A4.313,4.313,0,0,0,25.024,5.177ZM13.806,22.436H10.355V20.71h3.452Zm-1.726-6.472a2.157,2.157,0,1,1,2.157-2.157A2.157,2.157,0,0,1,12.081,15.964Zm6.9,6.472H15.532V20.71h3.452Zm5.177,0H20.71V20.71h3.452Zm-1.726-6.472a2.157,2.157,0,1,1,2.157-2.157A2.157,2.157,0,0,1,22.436,15.964ZM32.79,12.081H31.065V22.436H32.79a1.724,1.724,0,0,0,1.726-1.726v-6.9A1.724,1.724,0,0,0,32.79,12.081Z",
    fill: "#f3732a",
    opacity: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.a33044b3b6423cf137b866ad8f7ebf2a.svg";
export { ForwardRef as ReactComponent };